import React from 'react';
import { graphql, compose } from 'react-apollo';
import BaseWidget from '../../../../widgets/baseWidget';
import { getGuestCardsActivitiesStatistics } from './queries/queries';
import GuestCardActivitiesWidget from '../../common/widgets/guestCardActivities';
import DataProcessor from '../../common/dataProcessors/guestCardActivitiesDataProcessor';
import { IaksByTypeDistribution } from '../../common/charts/iaksByTypeDistribution';
import { ErrorBoundary } from "../../../../errorBoundary/errorBoundary";

class GuestCardActivities extends BaseWidget {
  get statisticsData() {
    return this.props.data.statistics.churchManager.church.daily.guestCardActivities;
  }

  get dataProcessor() {
    return new DataProcessor(this.apiData, 'day');
  }

  render() {
    return (
      <GuestCardActivitiesWidget data={this.dataProcessor.data} title="Daily Guest Card Activities"
                                 loading={this.props.data.loading}
                                 comment={this.comment}>
        <IaksByTypeDistribution data={this.dataProcessor.byTypeChartData} />
      </GuestCardActivitiesWidget>
    );
  }
}

export default compose(
  graphql(getGuestCardsActivitiesStatistics,
    {
      options: {
        fetchPolicy: 'network-only',
        notifyOnNetworkStatusChange: true //e.vasilevsky TODO: make it default after updating react-apollo to the latest version
      }
    }),
  ErrorBoundary
)(GuestCardActivities);



// WEBPACK FOOTER //
// ./src/components/pages/statistics/church/daily/guestCardActivities.js